import { useQuery } from 'react-query';
import type { PaginatedMeetings } from 'src/core/types';

import axios from './axios';

const fetchUpcomingMeetings = (
  page = 1,
  startDate?: string | null,
  endDate?: string | null,
) =>
  axios
    .get<PaginatedMeetings>(
      `/posht/yashar/meetings/upcoming/?page=${page}` +
        (startDate ? `&start_datetime__date__gte=${startDate}` : '') +
        (endDate ? `&start_datetime__date__lte=${endDate}` : ''),
    )
    .then((res) => res.data);

export interface UseUpcomingMeetingsQueryProps {
  filters?: Partial<{
    startDate: string | null;
    endDate: string | null;
  }>;
  page?: number;
}

export function useUpcomingMeetingsQuery(props: UseUpcomingMeetingsQueryProps) {
  const { filters, page } = props;

  return useQuery<PaginatedMeetings>(
    ['upcoming-meetings', page, filters?.startDate, filters?.endDate],
    () => fetchUpcomingMeetings(page, filters?.startDate, filters?.endDate),
    { keepPreviousData: false },
  );
}
